/**
 * SFrame259 — Final record keeping + estate settled confirmation (rebuilt).
 */

import { Link, useParams } from 'react-router-dom';
import SettlementStepPage from '../settlement/SettlementStepPage';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';
import { useSettlement } from '../../contexts/SettlementContext';

const step = SETTLEMENT_PHASE_CONFIGS.close.steps.find((s) => s.id === 'cls-4')!;

function EstateSettledPanel() {
  const { estateId } = useParams<{ estateId: string }>();
  const { isArchived, settledAt, estate } = useSettlement();
  const validationPath = estateId ? `/sframe-258/${estateId}` : '/sframe-258';

  if (!isArchived) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50/80 p-4 text-sm text-amber-950">
        When every requirement passes on the validation screen, use <strong>Settle &amp; archive estate</strong> to
        lock this workspace. You will return here for the celebration banner and retention reminders.
        <div className="mt-3">
          <Link to={validationPath} className="font-semibold text-blue-800 hover:underline">
            Go to validation →
          </Link>
        </div>
      </div>
    );
  }

  const when = settledAt ? new Date(settledAt).toLocaleString() : '';

  return (
    <div className="rounded-2xl border border-emerald-300 bg-gradient-to-br from-emerald-50 to-white p-6 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-emerald-800">Estate settled</p>
      <h2 className="text-2xl font-bold text-emerald-950 mt-2">Thank you for stewarding this estate.</h2>
      <p className="text-sm text-emerald-900 mt-3 leading-relaxed">
        {estate?.ownerName ? `${estate.ownerName}'s` : 'This'} estate workspace is now archived in read-only mode
        {when ? ` as of ${when}` : ''}. Retain digital and physical records per your counsel's instructions and
        applicable law (often seven years for tax-related items).
      </p>
    </div>
  );
}

export default function SFrame259() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-6 space-y-6">
      <EstateSettledPanel />
      <SettlementStepPage step={step} phase="close" overviewRoute="/sframe-250" />
    </div>
  );
}
